import React from "react";

import { useT } from "src/internationalization";

const TableEmptyState: React.FC<{ isFilterResult?: boolean }> = ({ isFilterResult }) => {
  const t = useT();
  return isFilterResult ? (
    <p>{t("component.table.empty.text.filtered")}</p>
  ) : (
    <p>{t("general.table.empty")}</p>
  );
};

export default TableEmptyState;
